export default "__VITE_ASSET__Fzoen9I8__"